var exports = {
  "oX": "reorderCustomFieldsForm__jtUS6S",
  "qI": "listContainer__NYmx8m",
  "AS": "item__HKCy94",
  "JV": "reorderFeedback__E88g9x",
  "jg": "emptyContent__dPYtnM",
  "P_": "SanitizedHtml__hkAxDE",
  "lw": "BoxFeedbackCommitState__HpH5iz",
};

module.exports = exports;
